export const createPaymentLoadingContent = (paymentWindow: Window): void => {
    const doc = paymentWindow.document;
    doc.open();
    doc.close();

    doc.documentElement.innerHTML = `
        <head>
            <title>Przygotowywanie płatności...</title>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <style>
                * {
                    box-sizing: border-box;
                    font-family: 'Poppins', sans-serif;
                    margin: 0;
                    padding: 0;
                }

                :root {
                    --color-primary: #030D45;
                    --color-alt: #0255AA;
                    --color-white: #FFFFFF;
                    --color-alt-second: #F2F5F9;
                }

                body {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    height: 100vh;
                    background: var(--color-alt-second);
                    color: var(--color-primary);
                    text-align: center;
                }

                .container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 20px;
                    padding: 40px;
                    background: var(--color-white);
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                    max-width: 400px;
                    width: 90%;
                }

                .logo {
                    max-width: 200px;
                    height: auto;
                }

                .indicator-wrapper {
                    position: relative;
                    width: 64px;
                    height: 64px;
                }

                .indicator-logo {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 56px;
                    height: 56px;
                    filter: brightness(0) saturate(100%) invert(21%) sepia(95%) saturate(2285%) hue-rotate(201deg) brightness(97%) contrast(101%);
                }

                .circle {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border: 3px solid transparent;
                    border-top-color: var(--color-alt);
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }

                h2 {
                    font-size: 18px;
                    font-weight: 600;
                    color: var(--color-primary);
                    margin: 0;
                }

                p {
                    font-size: 14px;
                    color: var(--color-primary);
                    margin: 0;
                    opacity: 0.8;
                }

                .subtitle {
                    font-size: 12px;
                    margin-top: 10px;
                }
            </style>
        </head>
        <body>
            <div class="container">
                <img src="/icons/investoro_pdf_logo.png" alt="Investoro Logo" class="logo" />
                
                <div class="indicator-wrapper">
                    <img src="/logo_favicon.png" alt="Skaner logo" class="indicator-logo" />
                    <div class="circle"></div>
                </div>

                <h2>Przygotowywanie płatności</h2>
                <p class="subtitle">Za chwilę zostaniesz przekierowany do bramki płatności</p>
            </div>
        </body>
    `;
};
